import styled, { css } from 'styled-components';

import { theme } from '../ui/theme';

interface TrProps {
    inactive?: boolean;
    focused?: boolean;
    unread?: boolean;
}

export const Tr = styled.tr<TrProps>`
    color: ${(props) => (props.inactive ? theme.colors.foreground.disabled : 'inherit')};
    font-weight: ${(props) => (props.focused ? theme.fontWeights[700] : 'inherit')};
    ${(props) =>
        props.unread
            ? css`
                  td {
                      font-weight: ${theme.fontWeights[600]};
                  }
              `
            : null};
`;
